import { HighlightableButton } from '@monofe/ui-common';
import { memo, useCallback } from 'react';
import { StyleElement, classNameForElement, styleForElement } from './SideMenuItemView.style';
import type { IHamburgerSideMenuItemViewProperties } from './interface';

function useOnClick(properties: IHamburgerSideMenuItemViewProperties) {
    return useCallback(() => {
        if (typeof properties.onClick === 'function') {
            properties.onClick(properties);
        }
    }, [properties]);
}

function SideMenuItemView(properties: IHamburgerSideMenuItemViewProperties): JSX.Element {
    const style = useCallback(
        (element: StyleElement) => styleForElement(element, properties),
        [properties],
    );
    const className = useCallback(
        (element: StyleElement) => classNameForElement(element, properties),
        [properties],
    );

    const onClick = useOnClick(properties);
    const href = typeof properties.onClick === 'string' ? properties.onClick : undefined;

    return (
        <HighlightableButton
            isLink
            href={href}
            onClick={typeof properties.onClick === 'function' ? onClick : undefined}
            className={className(StyleElement.Container)}
            style={style(StyleElement.Container)}
        >
            <span
                className={className(StyleElement.TitleText)}
                style={style(StyleElement.TitleText)}
            >
                {properties.title.text}
            </span>
        </HighlightableButton>
    );
}

export default memo(SideMenuItemView);
